import { render, staticRenderFns } from "./AuthenticatedLayout.vue?vue&type=template&id=6b72099a&"
import script from "./AuthenticatedLayout.vue?vue&type=script&lang=js&"
export * from "./AuthenticatedLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports